import React, { useState, useEffect } from 'react';
import CommunityDetail from './Detail';

export default props=>{
    // console.log("FixedDetail.js: ", props.me);
    const jsx = (<div className="">
        <style jsx>{`

.suppress {
    height: 100%;
    padding: 60px 0 0;
    width: 100%;
    text-align: left;
}

.header {
    font-size: 28px;
    position: fixed;
    top: 18px;
    left: calc( 50% + 464px );
}
.closeButton {
    float: right;
    cursor: pointer;
    color: white;
    transform: translate(0, 9px);
}

.grasp {
    height: 100%;
    background-color: #fefefe;
}

.fallback {
    position: fixed;
    z-index: 20;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.5);

    text-align: center;
}


@media all and (max-width:606px) {

    .fallback{
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        overflow-y: overlay;
    }

    .suppress{
        position: initial;
        padding: 0;
        height: auto;
    }
}

.full100{
    height: 100%;
}

`}</style>

        <div className="fallback" style={{ display: props.display }} onClick={props.hide} >
            <div className="suppress">
                <div className="header">&nbsp;
                <div className="closeButton" >&times;</div>
                </div>
                <div className="grasp full100" onClick={(e) => { e.stopPropagation() }}>
                    <CommunityDetail hide={props.hide} me={props.me} 
                        index={props.index}
                        maxListSize={props.maxListSize}
                        move={props.move}
                        likePlus={props.likePlus}
                    />
                </div>
            </div>
        </div>

    </div>);
    return jsx;
}
